export default {
  CLIENTINFO (state, info) {
    state.clientinfo.ip = info.ip, 
    state.clientinfo.city = info.city, 
    state.clientinfo.region = info.region, 
    state.clientinfo.region_code = info.region_code, 
    state.clientinfo.country = info.country, 
    state.clientinfo.country_code = info.country_code, 
    state.clientinfo.country_code_iso3 = info.country_code_iso3, 
    state.clientinfo.country_capital = info.country_capital, 
    state.clientinfo.country_tld = info.country_tld, 
    state.clientinfo.country_name = info.country_name, 
    state.clientinfo.continent_code = info.continent_code, 
    state.clientinfo.in_eu = info.in_eulse, 
    state.clientinfo.postal = info.postal, 
    state.clientinfo.timezone = info.timezone, 
    state.clientinfo.utc_offset = info.utc_offset, 
    state.clientinfo.country_calling_code = info.country_calling_code, 
    state.clientinfo.currency = info.currency, 
    state.clientinfo.currency_name = info.currency_name, 
    state.clientinfo.languages = info.languages, 
    state.clientinfo.country_area = info.country_area, 
    state.clientinfo.country_population = info.country_population, 
    state.clientinfo.asn = info.asn, 
    state.clientinfo.org = info.org
  },
  LOGIN (state, info) {
      state.usuario = { ...info }
  },
}